import { useContext } from 'react';

import configsContext from './context';

export default function useConfigs() {
    return useContext(configsContext);
}
